module.exports = "<section class=\"admission-container\">\r\n\t<h2>Admission Chairperson</h2>\r\n<br><br>\r\n\t<p>\r\n\t\t<img src=\"http://www.gbu.ac.in/images/GBU_Image_Indu Uprety.png\" width=\"100\" height=\"100\">\r\n\t\t<br><br>\r\n\t\t<b>Dr. Indu Uprety</b>\r\n\t\t<br><br>\r\n\t\t\tChairperson Admission and Examination\r\n\t\t\t<br><br>Gautam Buddha University\r\n\t\t\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admissions/components/chairperson-admissions/chairperson-admissions.component.html
// module id = ./src/app/admissions/components/chairperson-admissions/chairperson-admissions.component.html
// module chunks = main